import {ActionList, CounterLabel} from '@primer/react'

import {LABELS} from '../../../constants/labels'
import type {RelatesToConnection, RelatesToIssueNode} from '../../../mocks/relates-to/relates-to-types'
import {DependencyIssue} from './DependencyIssue'
import {asDependencyIssueFragment, RelationshipsRelatesToListView} from './RelationshipsRelatesToListView'
import styles from './RelationshipsSection.module.css'
import {RelationshipsViewAllButton} from './RelationshipsViewAllButton'

export type RelatesToGroupProps = {
  // Capped connection rendered in the sidebar (first N + `hasNextPage`).
  topRelatesTo: RelatesToConnection
  // Full node set handed to the "view all" modal.
  relatesToNodes: readonly RelatesToIssueNode[]
  relatesToCount: number
  showDivider: boolean
  onLinkClick?: (event: MouseEvent) => void
}

// TODO(#23079): mock-backed sidebar group for "relates to". Extracted so all mock coupling lives in one place;
// once the GraphQL `topRelatesTo` connection lands this renders straight off the fragment and the
// `asDependencyIssueFragment` cast disappears.
export function RelatesToGroup({
  topRelatesTo,
  relatesToNodes,
  relatesToCount,
  showDivider,
  onLinkClick,
}: RelatesToGroupProps) {
  return (
    <>
      {showDivider && <ActionList.Divider className={styles.ActionList_Divider} />}
      <ActionList.Group>
        <ActionList.GroupHeading as="h4" className={styles.ActionList_GroupHeading}>
          {LABELS.relationNames.relatesToIssues}
          {relatesToCount > 0 && (
            <CounterLabel className={styles.RelationshipCountLabel} variant="secondary" data-testid="relates-to-count">
              {relatesToCount}
            </CounterLabel>
          )}
        </ActionList.GroupHeading>
        {topRelatesTo.nodes.map(relatedIssue => (
          <DependencyIssue
            key={relatedIssue.id}
            onLinkClick={onLinkClick}
            issue={asDependencyIssueFragment(relatedIssue)}
          />
        ))}
        {topRelatesTo.pageInfo.hasNextPage && (
          <RelationshipsViewAllButton
            dialogTitle={LABELS.relationNames.relatesToIssues}
            // Total related count (no open/closed distinction in the mock). TODO(#23079): source this
            // from the real `issueDependenciesSummary` once the GraphQL field lands.
            countOpenItems={relatesToCount}
          >
            <RelationshipsRelatesToListView relatesToNodes={relatesToNodes} onLinkClick={onLinkClick} />
          </RelationshipsViewAllButton>
        )}
      </ActionList.Group>
    </>
  )
}
